module.exports = __webpack_public_path__ + "static/img/photo_jiaoyu.c2fc323.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_jiaoyu.png
// module id = 3UaI
// module chunks = 12